import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    notifications: [],
    notificationDetails: [],
};

const notificationsSlice = createSlice({
    name: "notificationsSlice",
    initialState,
    reducers: {
        // => Set not's
        setNotifications: (state, action) => {
            state.notifications = action.payload;
        },

        resetNotificationStates: (state) => {
            state.notifications = {};
        },
    },
});

export const { setNotifications, resetNotificationStates } =
    notificationsSlice.actions;
export default notificationsSlice.reducer;
